/** End the session and leave the app; forgets the last opened project so the next account does not inherit it */

import { apiClient } from './api-client'
import { useAppStore } from '../stores/app-store'

export async function signOut(): Promise<void> {
  try {
    await apiClient.post('/api/auth/logout')
  } catch (err) {
    // Still leave the app: the session cookie is cleared or already invalid
    console.error('Logout request failed:', err)
  }
  useAppStore.getState().setLastProjectSlug(null)
  window.location.href = '/login'
}
